<div class="avatar-wrapper" [ngClass]="'avatar-' + size()">
  @if (hasImage()) {
    <p-avatar
      [image]="imageUrl()"
      [size]="primengSize()"
      shape="circle">
    </p-avatar>
  } @else {
    <p-avatar
      icon="fa-solid fa-user text-primary-hiquo"
      [size]="primengSize()"
      shape="circle"
      style="background: white;">
    </p-avatar>
  }

  @if (hasSubscription()) {
    <div class="subscription-badge" [pTooltip]="planOption()?.text" tooltipPosition="right" [ngClass]="'badge-' + (size() || 'normal')">
       <img [src]="planOption()?.image" [ngClass]="primengSize() == 'xlarge' ? 'w-6 h-6' : 'w-4 h-4'" class="object-contain" />
    </div>
  }
</div>